import React, { Component } from 'react';
import Nav from './Nav';

class Header extends Component {

  render() {
    return (
      <div className="App-header">
        <Nav />
        <div className="title-bar">
          <div className="heading">
            <span><strong>SNAP</strong></span><span>CHALLENGE</span>
          </div>
          <div className="sub-heading">
            <span>CONNECT. PLAY. PHILANTHROPIZE.</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js